<div class="confirm-modal form-offer __inform" [class.mobile]="isMobile">
    <div class="confirm-modal-wrap credit-alert animated zoomIn" [class.zoomOut]="zoomOut">
        <div class="confirm-modal-message">
            <div class="confirm-modal-message__image">
                <img src="assets/images/icons/offers/36-alert.svg" width="48" height="48" alt="warning">
            </div>
            <h3 class="confirm-modal-message__h3">{{ current.title }}</h3>
            <div class="confirm-modal-message__desc">
                <p *ngFor="let parts of lines">
                    <ng-container *ngFor="let part of parts"><strong *ngIf="part.bold">{{ part.text }}</strong><ng-container *ngIf="!part.bold">{{ part.text }}</ng-container></ng-container>
                </p>
            </div>
        </div>
        <div class="confirm-modal-buttons">
            <button type="button" class="confirm-modal-buttons__continue" (click)="close($event)">Got it</button>
        </div>
    </div>
</div>
